import cx from 'classnames';
import * as React from 'react';

import tooltipable from 'lib/tooltipable';
import { ButtonColorUnion } from 'components/ButtonDeprecated';
import ClickEventTrigger from 'components/ClickEventTrigger';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import LinkBase from 'components/LinkBase';
import { Props as LinkBaseProps } from 'components/LinkBase';
import userAgent from 'lib/currentUserAgent';

import './styles/Link.scss';

export type Props = {
  bar?: boolean;
  className?: string;
  color?: ButtonColorUnion | 'inherit';
  underline?: boolean;
  weight?: 'normal' | 'semibold';
  disabled?: boolean;
  block?: boolean | 'inline';
  noWrap?: boolean;
  noHover?: boolean;
  rel?: string;
  target?: string;
  eventElementName?: string;
  eventKey?: string;
  eventProperties?: { [key: string]: any };
  eventScreenName?: string;
  children?: React.ReactNode;
} & LinkBaseProps;

class Link extends React.Component<Props> {
  static propClasses = {
    color: {
      apple: 'Link-apple',
      atlas: 'Link-atlas',
      mascot: 'Link-mascot',
      pennant: 'Link-pennant',
      chalkboard: 'Link-chalkboard',
      graphite: 'Link-graphite',
      whiteout: 'Link-whiteout',
      inherit: 'Link-inherit',
      pencil: 'Link-pencil',
      ink: 'Link-ink',
      koolaid: 'Link-koolaid',
    },
    noWrap: 'Link--noWrap',
    noHover: 'Link--noHover',
    underline: 'Link--underline',
    weight: {
      normal: 'Link--normal',
      semibold: 'Link--semibold',
    },
  };

  render() {
    const { bar, block, disabled, children, className, rel, target, ...props } = this.props;
    const targetBlankRel = (() => {
      let baseRel = 'noopener';
      if (!userAgent.noreferrerSupported()) {
        baseRel += ' noreferrer';
      }
      return baseRel;
    })();
    let safeRel;

    if (rel && target === '_blank') {
      safeRel = `${rel} ${targetBlankRel}`;
    } else if (target === '_blank') {
      safeRel = targetBlankRel;
    }
    const anyCast: any = this;
    return (
      <ClickEventTrigger
        eventElementName={this.props.eventElementName}
        eventKey={this.props.eventKey}
        eventProperties={this.props.eventProperties}
        eventScreenName={this.props.eventScreenName}
      >
        <LinkBase
          {...props}
          rel={safeRel}
          target={target}
          className={cx(
            'Link',
            {
              'Link-bar': bar,
              'Link-disabled': disabled,
              'Link-block': block === true,
              'Link-inlineBlock': block === 'inline',
            },
            getPropClassesFromInstance(anyCast),
            className
          )}
          disabled={disabled}
        >
          {children}
        </LinkBase>
      </ClickEventTrigger>
    );
  }
}

export { Link };
export default tooltipable(Link);
